import React, { useEffect, useState, useCallback, useRef } from "react";
import { Helmet } from "react-helmet";
import "./Information.css";
import graphics1 from "../../assets/imgs/info/graphics (1).png";
import graphics2 from "../../assets/imgs/info/graphics (2).png";
import graphics3 from "../../assets/imgs/info/graphics (3).png";
import graphics4 from "../../assets/imgs/info/graphics (4).png";
import graphics5 from "../../assets/imgs/info/graphics (5).png";
import graphics6 from "../../assets/imgs/info/graphics (6).png";
import graphics7 from "../../assets/imgs/info/graphics (7).png";
import graphics8 from "../../assets/imgs/info/graphics (8).png";

const infoData = [
    {
        title: "Professional Real Estate Websites for Agents & Teams",
        text: "Build a high-impact website crafted for real estate professionals. Perfect for agents, teams, and brokerages—all.",
        image: graphics1,
    },
    {
        title: "Mobile-Optimized & Responsive Design",
        text: "Enjoy a experience on any device. Our responsive design ensures your site looks great on desktop, tablet, or mobile, connecting you with every prospect.",
        image: graphics2,
    },
    {
        title: "Customizable Templates & Complete Control",
        text: "Choose from a variety of stylish templates built for real estate, and manage your site effortlessly with our secure dashboard and intuitive tools.",
        image: graphics3,
    },
    {
        title: "Built-In SEO & Marketing Tools",
        text: "Enhance your online presence with integrated SEO features and marketing tools designed to attract more leads and boost your brand.",
        image: graphics4,
    },
    {
        title: "Affordable, All-Inclusive Plans",
        text: "Have your own website without breaking the bank. Our cost-effective plans provide everything you need to thrive in a competitive market.",
        image: graphics6,
    },
    {
        title: "IDX Integration for Listings",
        text: "Seamlessly display all your MLS listings on your website with our IDX support. Keep your site up-to-date and provide visitors with the latest properties automatically.",
        image: graphics7,
    },
    {
        title: "Social Media Integration & Add-Ons",
        text: "Expand your reach with our social media add-ons. We offer professional management, content creation, and analytics to help you grow your brand across all major platforms.",
        image: graphics8,
    },
];

const ANIMATION_DURATION = 600; // ms
const AUTO_SWITCH_INTERVAL = 2000; // 2 seconds

const Information = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    // Change direction default to "right" for consistency
    const [direction, setDirection] = useState("right"); // "right" for next, "left" for prev
    const [isAnimating, setIsAnimating] = useState(false);
    const [nextIndex, setNextIndex] = useState(null);
    const autoSwitchRef = useRef();

    // Auto-switch every 2 seconds
    useEffect(() => {
        autoSwitchRef.current = setInterval(() => {
            if (!isAnimating) {
                setDirection("right");
                setNextIndex((currentIndex + 1) % infoData.length);
                setIsAnimating(true);
                setTimeout(() => {
                    setCurrentIndex((prev) => (prev + 1) % infoData.length);
                    setIsAnimating(false);
                    setNextIndex(null);
                }, ANIMATION_DURATION);
            }
        }, AUTO_SWITCH_INTERVAL);
        return () => clearInterval(autoSwitchRef.current);
    }, [currentIndex, isAnimating]);

    // Only allow dot click to change section
    const handleDotClick = (idx) => {
        if (idx !== currentIndex && !isAnimating) {
            // Change: up = left, down = right
            const dir = idx > currentIndex ? "right" : "left";
            setDirection(dir);
            setNextIndex(idx);
            setIsAnimating(true);
            setTimeout(() => {
                setCurrentIndex(idx);
                setIsAnimating(false);
                setNextIndex(null);
            }, ANIMATION_DURATION);
        }
    };

    const renderSection = (index, animType, key) => {
        const { title, text, image } = infoData[index];
        return (
            <div
                key={key}
                className={`info-section-content info-section-animating ${animType}`}
            >
                <div className="info-image-container">
                    <img src={image} alt={title} className="info-image" />
                </div>
                <div className="info-content">
                    <h2>{title}</h2>
                    <p>{text}</p>
                </div>
            </div>
        );
    };

    return (
        <>
            <Helmet>
                <title>Real Estate Website Features | AptoWebsites</title>
                <meta name="description" content="Discover the features of AptoWebsites: mobile-optimized, SEO-ready, IDX integration, social media add-ons, and more for real estate professionals." />
                <meta name="keywords" content="real estate website features, IDX, SEO, mobile, social media, AptoWebsites" />
                <meta property="og:title" content="Real Estate Website Features | AptoWebsites" />
                <meta property="og:description" content="Discover the features of AptoWebsites: mobile-optimized, SEO-ready, IDX integration, social media add-ons, and more." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/" />
            </Helmet>
            <div className="information-page single-section">
                {/* <h1 className="titles">Comprehensive Real Estate Websites</h1> */}
                <div className="info-section-animator">
                    {isAnimating && nextIndex !== null && (
                        <>
                            {renderSection(
                                currentIndex,
                                direction === "right" ? "slide-out-left" : "slide-out-right",
                                "current"
                            )}
                            {renderSection(
                                nextIndex,
                                direction === "right" ? "slide-in-right" : "slide-in-left",
                                "next"
                            )}
                        </>
                    )}
                    {!isAnimating && renderSection(currentIndex, "slide-in-instant", "current")}
                </div>
                <div className="info-section-pagination">
                    {infoData.map((_, idx) => (
                        <span
                            key={idx}
                            className={`info-section-dot${idx === currentIndex ? " active" : ""}`}
                            onClick={() => handleDotClick(idx)}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default Information;
